<mat-accordion>
    <mat-expansion-panel [expanded]="panelOpenState">
        <mat-expansion-panel-header class="v-bg-primary">
            <mat-panel-title>
                <span class="text-light fs-5 f-bold">New/Edit Client</span>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <form [formGroup]="newclientform">
            <div class="container pt-3">
                <div class="row">
                    <div class="col-sm">
                        <mat-form-field>
                            <input matInput formControlName="name" placeholder="Name">
                        </mat-form-field>
                        <!-- <h5>Roadbooks <button mat-icon-button color="accent" (click)="openDialog()">
                            <mat-icon>add</mat-icon>
                          </button></h5>
                        <mat-list>
                            <mat-list-item *ngFor="let ri of currentRoadbooksIds">{{ roadbooksDict[ri]?.name }}</mat-list-item>
                        </mat-list> -->
                        <h5>Roadbooks <button mat-icon-button color="accent" (click)="openDialog()">
                            <mat-icon>add</mat-icon>
                        </button></h5>
                    </div>
                    <div class="col-sm">
                        <mat-form-field>
                            <input matInput formControlName="code" placeholder="Activation Code">
                        </mat-form-field>
                        <div class="mt-1">
                            <mat-checkbox formControlName="visible">Visible</mat-checkbox>
                        </div>
                    </div>
                </div>

                <!-- <mat-list>
                    <mat-list-item *ngFor="let ri of currentRoadbooksIds">{{ roadbooksDict[ri]?.name }}</mat-list-item>
                </mat-list> -->
                <mat-chip-list>
                    <mat-chip *ngFor="let ri of currentRoadbooksIds" class="v-bg-primary text-light">{{ roadbooksDict[ri]?.name }}</mat-chip>
                </mat-chip-list>
            </div>
            <hr>
            <button (click)="saveClient()" [disabled]="!newclientform.valid" class="btn btn-success">Save Client</button>
            <button style="margin-left: 20px" (click)="reset()" class="btn btn-danger">Cancel</button>
        </form>
    </mat-expansion-panel>
</mat-accordion>
<mat-form-field>
    <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtre">
</mat-form-field>

<div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
        <ng-container matColumnDef="star" stickyEnd>
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
                <button mat-icon-button (click)="editElemet(element)">
        <mat-icon>edit</mat-icon>
      </button>
                <button mat-icon-button (click)="removeElemet(element)">
        <mat-icon>delete</mat-icon>
      </button>
            </td>
        </ng-container>

        <!-- <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
            <td mat-cell *matCellDef="let row"> {{row.id}} </td>
        </ng-container> -->

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
            <td mat-cell *matCellDef="let row" (click)="expandedElement = expandedElement === row ? null : row"> {{row.n}} </td>
        </ng-container>

        <ng-container matColumnDef="code">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Code </th>
            <td mat-cell *matCellDef="let row" (click)="expandedElement = expandedElement === row ? null : row"> {{row.c}} </td>
        </ng-container>
        <ng-container matColumnDef="visible">
            <th mat-header-cell *matHeaderCellDef> Visible </th>
            <td mat-cell *matCellDef="let row">
                <mat-checkbox style="margin-left: 20px!important;" [disabled]="row.destinated_users === 2" (change)="changeCheckBox(row, $event)" [checked]="row.v">
                </mat-checkbox>
            </td>
        </ng-container>
        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="4">
                <div class="example-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                    <div class="container" style="padding: 20px;">
                        <mat-card style="background-color: #e9e9e9">
                            <div><span style="font-weight: bold;">Id: </span>{{element.i}} </div>
                            <div><span style="font-weight: bold;">Code: </span>{{element.c}} </div>
                            <div><span style="font-weight: bold;">Name: </span>{{element.n}} </div>
                            <div><span style="font-weight: bold;">Roadbooks: </span>
                                <mat-chip-list>
                                    <mat-chip *ngFor="let ri of element.r" class="v-bg-primary text-light">{{ roadbooksDict[ri]?.name }}</mat-chip>
                                </mat-chip-list>
                            </div>
                        </mat-card>
                    </div>
                </div>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="example-element-row" [class.example-expanded-row]="expandedElement === row"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[25, 50, 100, 150]"></mat-paginator>
</div>